import { defineStore } from 'pinia';

import type { Invoice } from '@stuut/api/models';

import { stuut } from '@/api';

interface State {
  invoices: Invoice[];
  invoiceSelect: Invoice[];
  partnerInvoices: Record<string, Invoice[]>;
  selectInitLoad: boolean;
}

export const useInvoices = defineStore('invoices', {
  actions: {
    async fetchInvoiceSelect(args?) {
      const invoiceSelect = await stuut.invoices.list(args);

      this.$patch({ invoiceSelect });

      return this.invoiceSelect;
    },

    async getPeekFindSelect(id) {
      const record = this.getSelectById(id);

      if (record) return record;

      const invoice = await stuut.invoices.retrieve(id);

      this.invoiceSelect = [...this.invoiceSelect, invoice];

      return invoice;
    },

    async setupInvoiceSelect(args) {
      if (this.invoiceSelect?.length || this.selectInitLoad) return;

      this.selectInitLoad = true;

      const invoices = await this.fetchInvoiceSelect(args);

      return invoices;
    },
  },

  getters: {
    getById: (state) => {
      return (invoiceId: string) =>
        state.invoices.find((invoice) => invoice.id === invoiceId) as Invoice | undefined;
    },

    getSelectById: (state) => {
      return (id: string) => state.invoiceSelect.find((invoice) => invoice?.id === id);
    },
  },

  state: (): State => ({
    invoices: [],
    invoiceSelect: [],
    partnerInvoices: {},
    selectInitLoad: false,
  }),
});

export default useInvoices;
